import {Elevation} from "@blueprintjs/core";
import React, {useEffect} from "react";
import {
  CardContainer,
  CardGrid,
  DetailedCard,
  ScrollableList,
  StopListContainer
} from "../../common/styles/cards.style";
import {ManifestCardHeaderV2, StopInfoItem} from "../../common/components/ManifestCardCommonV2";
import {Constants} from "../../../../../../../constants/constants";
import AssignmentLoadingWrapper from "../../common/components/AssignmentLoadingWrapper";
import {ManifestCardPropsV2} from "../../common/types/cards.type";
import {createCardHandlers} from "../../common/utils/cardHandlers";
import {scrollToElement} from "../../common/utils/scrollToElement";
import {getStopList} from "../../common/utils/getStopList";

const ManifestDriverDetailedCard = React.memo(
  ({
    manifest,
    colors,
    isSelected,
    isHighlighted,
    disabled,
    isTimeFormat24hr,
    timezoneOfJobStop,
    cardConfigurations,
    onSelectedManifest,
    onDrillDownManifest,
    onLocationMarkerClick,
    isPending
  }: ManifestCardPropsV2) => {
    const {handleOnSelected, handleDrillDownManifest} = createCardHandlers({
      onSelectedManifest,
      onDrillDownManifest
    });

    const stopList = getStopList(
      manifest,
      isSelected,
      cardConfigurations.topStopInformation,
      Constants.NUMBER_OF_DETAILED_CARD_STOPS
    );

    useEffect(() => {
      if (isSelected) {
        scrollToElement(`manifest-detailed-card-item-${manifest.manifestDriverId}`);
      }
    }, [isSelected, manifest.manifestDriverId]);

    return (
      <AssignmentLoadingWrapper isLoading={isPending}>
        <CardContainer
          id={`manifest-dnd-target-${manifest.manifestDriverId}`}
          data-manifestdriverid={manifest.manifestDriverId}
          data-cardtype={"card"}
        >
          <DetailedCard
            id={`manifest-detailed-card-item-${manifest.manifestDriverId}`}
            elevation={Elevation.ONE}
            isSelected={isSelected}
            isHighlighted={isHighlighted}
            interactive={!disabled}
            disabled={disabled}
            data-testid={`manifest-detailed-card-item-${manifest.manifestDriverId}`}
            onClick={(e: any) => {
              if (!disabled) {
                handleOnSelected(e, manifest);
              }
            }}
          >
            <CardGrid data-testid={"card-grid"} isSelected={isSelected} bodyHeight={105}>
              <ManifestCardHeaderV2
                manifest={manifest}
                handleDrillDownManifest={handleDrillDownManifest}
                onLocationMarkerClick={onLocationMarkerClick}
                stopsColor={colors ?? []}
                isSelected={isSelected}
                disabled={disabled}
                cardConfigurations={cardConfigurations}
              />
              <StopListContainer>
                <ScrollableList
                  id={`scroll-list-${manifest.manifestDriverId}`}
                  data-testid="scroll-list"
                  isSelected={isSelected}
                  hasScroll={(stopList ?? []).length > Constants.NUMBER_OF_DETAILED_CARD_STOPS}
                >
                  {stopList?.map((x, index) => {
                    const color = (colors ?? []).find((y) => y.jobStopID === x.jobStopId)?.color ?? "";
                    return (
                      <StopInfoItem
                        index={index}
                        key={`card-stop-info-${x.jobStopId}`}
                        stop={x}
                        color={color}
                        disabled={disabled ?? false}
                        cardConfigurations={cardConfigurations}
                        isTimeFormat24hr={isTimeFormat24hr}
                        timezoneOfJobStop={timezoneOfJobStop}
                      />
                    );
                  })}
                </ScrollableList>
              </StopListContainer>
            </CardGrid>
          </DetailedCard>
        </CardContainer>
      </AssignmentLoadingWrapper>
    );
  }
);
ManifestDriverDetailedCard.displayName = "ManifestDriverDetailedCard";

export default ManifestDriverDetailedCard;
